<template>
  <div class="frontend w-100 d-flex justify-content-center align-items-center vh-100">
    <div
      v-show="$store.state.appConfig.showLoader"
      class="axios-loader"
    >
      <loader />
    </div>

    <div
      v-if="$route.query.success && $route.query.success == 'true'"
      class="mx-auto my-auto"
      style="text-align: center; padding-left: 40px; padding-right: 40px;"
    >
      <div
        style="width: 100px; height: 100px; border-radius: 50%; background-color: #438F5D; margin-bottom: 30px;"
        class="mx-auto d-flex justify-content-center align-items-center"
      >
        <feather-icon
          icon="CheckIcon"
          size="50"
          class="text-white"
        />
      </div>
      <p style="color: #6A5E32; font-size: 28px; text-align: center; line-height: 36px;">
        Singpass authentication successful
      </p>
      <p style="text-align: center; color: #5F5E5E; line-height: 23px;">
        To continue in the Nirvana SG app, click <span style="font-weight: 700;">Cancel</span> above and you’ll be redirected to the app.
      </p>
    </div>
    <div
      v-else
      class="mx-auto my-auto"
      style="text-align: center; padding-left: 40px; padding-right: 40px;"
    >
      <div
        style="width: 100px; height: 100px; border-radius: 50%; background-color: #F4333D; margin-bottom: 30px;"
        class="mx-auto d-flex justify-content-center align-items-center"
      >
        <feather-icon
          icon="XIcon"
          size="50"
          class="text-white"
        />
      </div>
      <p style="color: #6A5E32; font-size: 28px; text-align: center; line-height: 36px;">
        Singpass Authentication Failed
      </p>
      <p style="text-align: center; color: #5F5E5E; line-height: 23px;">
        To continue in the Nirvana SG app, click <span style="font-weight: 700;">Cancel</span> above and you’ll be redirected to the app.
      </p>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue'

export default {
  components: {
    Loader,
  },
}
</script>
